var exports = {
  "L": "toggle__ds22s_",
};

module.exports = exports;
